module.exports = __webpack_public_path__ + "img/2FA.31568ad6.png";